var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card bs-4 bgc-primary"},[_vm._v(" Closing Session... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }